var _excluded = ["children", "errorMessage", "fieldSize", "id", "labelledBy", "legend", "message", "required"],
  _excluded2 = ["children", "fieldSize"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import styled from 'styled-components';
import FieldError from "../FieldError/FieldError.js";
import FieldMessage from "../FieldMessage/FieldMessage.js";
/* ChoiceList and children */
var ChoiceListContainer = styled.fieldset.withConfig({
  componentId: "CL__sc-12eiggs-0"
})(["& > *:not(legend):not(:last-child){margin-bottom:var( --spacing-", " );}"], _ref => {
  var {
    fieldSize
  } = _ref;
  return fieldSize === 'large' ? '3' : '1';
});
var LegendRequiredFlag = styled.abbr.withConfig({
  componentId: "CL__sc-12eiggs-1"
})(["color:var(--highlight-color);display:inline-block;text-decoration:none;"]);
var StyledLegend = styled.legend.withConfig({
  componentId: "CL__sc-12eiggs-2"
})(["display:block;color:var(--text-color);margin-bottom:var( --spacing-", " );", " ", " ", ""], _ref2 => {
  var {
    fieldSize
  } = _ref2;
  return fieldSize === 'large' ? '3' : '1';
}, _ref3 => {
  var {
    fieldSize
  } = _ref3;
  return fieldSize === 'large' && "\n      font: var(--body-text-medium);\n      font-weight: 600;\n\n      & ".concat(LegendRequiredFlag, " {\n        padding-left: var(--spacing-1);\n      }\n      ");
}, _ref4 => {
  var {
    fieldSize
  } = _ref4;
  return fieldSize === 'medium' && "\n      font: var(--body-text-small);\n      font-weight: 600;\n\n      & ".concat(LegendRequiredFlag, " {\n        padding-left: calc(var(--spacing-1) / 2);\n      }\n      ");
}, _ref5 => {
  var {
    fieldSize
  } = _ref5;
  return fieldSize === 'small' && "\n      font: var(--body-text-x-small);\n      font-weight: 600;\n\n      & ".concat(LegendRequiredFlag, " {\n        padding-left: calc(var(--spacing-1) / 2);\n      }\n      ");
});
var StyledFieldMessage = styled(FieldMessage).withConfig({
  componentId: "CL__sc-12eiggs-3"
})(["--choice-list-message-padding:", ";padding:var(--choice-list-message-padding) 0 0 3px;"], _ref6 => {
  var {
    fieldSize
  } = _ref6;
  return fieldSize === 'small' ? 'var(--spacing-1)' : fieldSize === 'medium' ? 'var(--spacing-1)' : '0';
});
var StyledFieldError = styled(FieldError).withConfig({
  componentId: "CL__sc-12eiggs-4"
})(["", ";--choice-list-error-padding:", ";padding:var(--choice-list-error-padding) 0 0;"], _ref7 => {
  var {
    fieldSize
  } = _ref7;
  return fieldSize === 'small' && 'margin-left: -3px;';
}, _ref8 => {
  var {
    fieldSize
  } = _ref8;
  return fieldSize === 'small' ? 'var(--spacing-1)' : fieldSize === 'medium' ? 'var(--spacing-1)' : '0';
});
var ChoiceList = _ref9 => {
  var {
      children,
      errorMessage,
      fieldSize = 'medium',
      id,
      labelledBy,
      legend,
      message,
      required = false
    } = _ref9,
    props = _objectWithoutProperties(_ref9, _excluded);
  return /*#__PURE__*/React.createElement(ChoiceListContainer, _extends({
    "aria-labelledby": labelledBy || "".concat(id, "-legend"),
    fieldSize: fieldSize,
    id: id,
    role: "group"
  }, props), legend && /*#__PURE__*/React.createElement(StyledLegend, {
    fieldSize: fieldSize,
    id: "".concat(id, "-legend"),
    required: required
  }, /*#__PURE__*/React.createElement("span", null, legend), required && /*#__PURE__*/React.createElement(LegendRequiredFlag, {
    "aria-label": "A choice is required",
    title: "A choice is required"
  }, "*")), children, message && !errorMessage && /*#__PURE__*/React.createElement(StyledFieldMessage, {
    fieldSize: fieldSize,
    htmlFor: id
  }, message), errorMessage && /*#__PURE__*/React.createElement(StyledFieldError, {
    fieldSize: fieldSize,
    htmlFor: id
  }, errorMessage));
};

/* Indented */

var ChoiceListIndentContainer = styled.div.withConfig({
  componentId: "CL__sc-12eiggs-5"
})(["padding-left:var( --spacing-", " );"], _ref10 => {
  var {
    fieldSize
  } = _ref10;
  return fieldSize === 'small' ? '3' : fieldSize === 'medium' ? '4' : '6';
});
var Indent = _ref11 => {
  var {
      children,
      fieldSize = 'medium'
    } = _ref11,
    props = _objectWithoutProperties(_ref11, _excluded2);
  return /*#__PURE__*/React.createElement(ChoiceListIndentContainer, _extends({
    fieldSize: fieldSize
  }, props), children);
};
ChoiceList.Indent = Indent;
export default ChoiceList;